import styled from "@emotion/native"
import TickIcon from "../../../assets/v2/Tick.svg"

type RadioButtonProps = {
  checked?: boolean
  handleCheck?: (newValue: boolean) => void
}

export function RadioButtonV2({ checked, handleCheck = () => null }: RadioButtonProps) {
  return (
    <Wrapper checked={checked} onPress={() => handleCheck(!checked)}>
      <TickIcon />
    </Wrapper>
  )
}

type ContentProps = {
  checked?: boolean
}

const Wrapper = styled.Pressable`
  width: 28px;
  height: 28px;
  border-radius: 100px;
  align-items: center;
  justify-content: center;
  border-width: 2px;
  border-color: ${(props: ContentProps) => (props.checked ? "#3B58E3" : "#BCBBBD")};
  background-color: ${(props: ContentProps) => (props.checked ? "#3B58E3" : "white")};
`
